import { GuidePriority } from "../guide";
import type { GuideContext, GuideStep } from "../guide";

/**
 * Captain Bram on the weekly event modes (MP-21, docs/MODES.md §5): the first battle of each, one line pointing at its
 * HUD tag (ui/runTag.ts) on what makes it different. Once per save, target required: no tag, no line.
 */

export const EventModeTargets = { boss: "#hud .runtag.boss", race: "#hud .runtag.race", odyssey: "#hud .runtag.odyssey" } as const;

const inLevel = (c: GuideContext): boolean => c.screen === "level" && c.level !== null;
const TIP = { kind: "tip", block: "none", needsTarget: true, screen: "level", priority: GuidePriority.NewThing } as const;

export const eventModeLevelSteps: readonly GuideStep[] = [
  { ...TIP, id: "hint.bossWeek", pose: "pointing", topic: "bossWeek", target: { dom: EventModeTargets.boss },
    text: "**Boss Week**, Commander! Each tier you beat opens a tougher one, right up to Elite.", when: inLevel },
  { ...TIP, id: "hint.raceWeek", pose: "laughing", topic: "raceWeek", target: { dom: EventModeTargets.race },
    text: "The clock is running! Call waves early for a faster time; it waits while you choose a card.", when: inLevel },
  { ...TIP, id: "hint.odyssey", pose: "pointing", topic: "odyssey", target: { dom: EventModeTargets.odyssey },
    text: "Mind the walls: every life lost here is gone for the next map too.", when: inLevel },
];
